import { gsap } from 'gsap';
import { init, enter } from '../animations';

export function pgSelectionEnter(el) {
  const slider = el.querySelector('.content__slider');
  const button = el.querySelector('.content__button');
  const tl = gsap.timeline();

  init.get('fade')(slider, { y: 40 });
  init.get('buttonRounded')(button);

  tl.addLabel('start')
    .to('.leaves.leaves--m.leaves--frame', {
      autoAlpha: 1,
      scale: 1,
      duration: 0.75,
      ease: 'power3.out',
    }, 'start')
    .add(enter.get('fade')(slider, 0, 0.75), 'start')
    .add(enter.get('buttonRounded')(button), 'start+=0.3');

  return tl;
}

export function pgSelectionLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to('.leaves.leaves--m.leaves--frame', {
      autoAlpha: 0,
      scale: 1.5,
      duration: 0.75,
      ease: 'power3.out',
    }, 'start')
    .to(el, { autoAlpha: 0, ease: 'power3.out', duration: 0.75 }, 'start');

  return tl;
}
